(function () {
    'use strict';

    angular.module("imApp").factory("custactProcessService", ['$ihttp', function ($ihttp) {
        let service = {
            listProcesses: function (parms) {
                return $ihttp.post({
                    method: 1855,
                    parameters: parms || {}
                });
            },
            saveObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1856,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
